import { render, staticRenderFns } from "./SimplePageLayout.vue?vue&type=template&id=cd6f6ffc&"
import script from "./SimplePageLayout.vue?vue&type=script&lang=ts&"
export * from "./SimplePageLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports